import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('balance_control'),
    subtitle: defineMessage('when_the_available_bala_yment_the_system_should'),
    allow: defineMessage('allow_sending_payments___for_overdraft_accounts'),
    disallow: defineMessage('do_not_allow_sending_pa__funds_are_insufficient'),
};
